/**
 * Promise wrapper around the FileReader API
 * @param  {File} file   File from the FileList object
 * @return {Promise}     A promise
 */
export const readAsDataURL = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.onload = e => resolve(e.target.result)
  reader.onerror = reject
  reader.readAsDataURL(file)
})

/**
 * Promise wrapper around the FileReader API
 * @param  {File} file   File from the FileList object
 * @return {Promise}     A promise
 */
export const getImageDimensions = (data) => new Promise((resolve) => {
  const img = new Image()
  img.onload = () => resolve({ width: img.width, height: img.height })
  img.src = data
})



/** WEBPACK FOOTER **
 ** ./src/utils/filereader/filereader.js
 **/